import { Divider, Skeleton, Typography, Box } from '@cast/design-system';
import { StorageActionsSummary } from '@cast/types-stop';

type RiskStatCellsProps = {
  storageActionsSummary: StorageActionsSummary;
  isLoading?: boolean;
};

export const RiskStatCells = ({
  storageActionsSummary,
  isLoading,
}: RiskStatCellsProps) => (
  <Box
    data-testid="risk-stat-cells"
    sx={{
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {[
      {
        value: storageActionsSummary.throttlingRiskMitigatedCount,
        label: 'Throttling risk mitigation',
        testId: 'throttling-risk-count',
      },
      {
        value: storageActionsSummary.performanceOverprovisioningCount,
        label: 'Performance overprovisioning risk mitigation',
        testId: 'overprovisioning-risk-count',
      },
      {
        value: storageActionsSummary.diskPressureRiskMitigatedCount,
        label: 'Disk pressure risk mitigation',
        testId: 'disk-pressure-risk-count',
      },
    ].map(({ value, label, testId }, idx) => (
      <Box
        key={label}
        sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}
      >
        {idx > 0 && <Divider />}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            px: 17,
            py: 16,
            flex: 1,
            justifyContent: 'center',
          }}
        >
          {isLoading ? (
            <Skeleton variant="text" width="100%" height={28} />
          ) : (
            <Typography variant="h5" data-testid={testId}>
              {value ?? '--'}
            </Typography>
          )}
          <Typography variant="P12R" color="textSecondary">
            {label}
          </Typography>
        </Box>
      </Box>
    ))}
  </Box>
);
